import { render, staticRenderFns } from "./QuestionnaireAnswerActions.vue?vue&type=template&id=2a21cc47&scoped=true&"
import script from "./QuestionnaireAnswerActions.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireAnswerActions.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionnaireAnswerActions.vue?vue&type=style&index=0&id=2a21cc47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21cc47",
  null
  
)

export default component.exports